import { ContainerMovementDialogStore } from '@tom-ui/utils'
import { JourneyPosition } from '@tom-ui/yard'
import { action, computed, makeObservable, observable } from 'mobx'
import { SlotPositionDto } from 'modules/operations/src/app/api'
import { CreateReservationRequest, CreateReservationResponse } from 'modules/yard/src/app/api'

export enum ContainerMovementAlertType {
  GenericError,
}

export interface InternalMovementServiceCalls {
  yardCreateReservation: (request: CreateReservationRequest) => Promise<CreateReservationResponse>

  operationsCreateInternalWorkInstruction: (createInternalWorkInstructionCommand: {
    containerJourneyId: number
    yardBlockId: string
    destination: SlotPositionDto[]
  }) => Promise<void>
}

export class ContainerMovementDialogViewStore {
  destination?: JourneyPosition
  submitAlerts: ContainerMovementAlertType[] = []

  constructor(
    private readonly containerMovementDialogStore: ContainerMovementDialogStore,
    private readonly internalMovementServiceCalls: InternalMovementServiceCalls,
  ) {
    makeObservable(this, {
      destination: observable,
      submitAlerts: observable,

      setDestination: action,
      submit: action,
      reset: action,

      alerts: computed,
    })
  }

  setDestination(destination?: JourneyPosition) {
    this.destination = destination
  }

  get alerts() {
    return [...this.submitAlerts]
  }

  async submit() {
    if (!this.destination) {
      throw new Error()
    }

    const alerts = await this.submitInternalMovement(
      this.containerMovementDialogStore.selectedContainer?.containerJourneyId,
      this.destination,
    )

    if (alerts.length > 0) {
      this.submitAlerts = alerts
      throw new Error()
    }
  }

  reset() {
    this.submitAlerts = []
    this.destination = undefined
  }

  submitInternalMovement = async (containerJourneyId: number, destination: JourneyPosition) => {
    const alerts = []
    try {
      //Yard
      const storageResponse = await this.internalMovementServiceCalls.yardCreateReservation({
        journeyId: containerJourneyId,
        blockId: destination.blockId,
        position:
          destination.bay && destination.row && destination.tier
            ? {
                bay: destination.bay,
                row: destination.row,
                tier: destination.tier,
              }
            : undefined,
      })

      //Operations
      const destinationDto = storageResponse.positions.map<SlotPositionDto>(x => ({
        bay: x.bay,
        row: x.row,
        tier: x.tier,
      }))

      await this.internalMovementServiceCalls.operationsCreateInternalWorkInstruction({
        containerJourneyId,
        yardBlockId: destination.blockId,
        destination: destinationDto,
      })
    } catch {
      alerts.push(ContainerMovementAlertType.GenericError)
    }

    return alerts
  }
}
